<div class="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-800 dark:bg-neutral-800/40">
  <button
    type="button"
    (click)="copyBadge(orderId)"
    [title]="'Copiar ' + orderId"
    class="inline-flex cursor-pointer items-center bg-transparent p-0 text-2xl font-bold tracking-tight text-neutral-900 focus-visible:outline-none dark:text-white"
  >
    <span>#{{ orderId }}</span>
  </button>

  @if (groupOrderIds.length > 1) {
    <div class="mt-2 flex flex-wrap items-center gap-1.5">
      @for (id of groupOrderIds; track id) {
        @if (id === orderId) {
          <span
            class="rounded-full border border-blue-600 bg-blue-600 px-2 py-0.5 text-xs font-mono font-semibold text-white"
            title="Pedido atual">
            {{ id }}
          </span>
        } @else {
          <a
            [routerLink]="['/orders/order-v2', id]"
            [title]="'Abrir pedido ' + id"
            class="rounded-full border border-neutral-200 bg-neutral-100 px-2 py-0.5 text-xs font-mono font-semibold text-neutral-700 no-underline transition-colors hover:border-blue-500 hover:bg-blue-50 hover:text-blue-700 dark:border-neutral-700 dark:bg-neutral-800 dark:text-neutral-300 dark:hover:border-blue-400 dark:hover:bg-blue-950 dark:hover:text-blue-300">
            {{ id }}
          </a>
        }
      }
    </div>
  }

  @if (statusLabel || invoiceNumber) {
    <div class="mt-2 flex flex-wrap items-center gap-1.5">
      @if (statusLabel) {
        <button
          type="button"
          (click)="copyBadge(statusLabel)"
          [title]="'Copiar status: ' + statusLabel"
          class="inline-flex cursor-pointer items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold focus-visible:outline-none"
          [ngClass]="statusBadgeClass"
        >
          <span class="font-medium opacity-80">status:</span>
          <span>{{ statusLabel }}</span>
        </button>
      }
      @if (invoiceNumber) {
        <button
          type="button"
          (click)="copyBadge(invoiceNumber)"
          [title]="'Copiar nota fiscal: ' + invoiceNumber"
          class="inline-flex cursor-pointer items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-xs font-mono font-semibold text-emerald-700 focus-visible:outline-none dark:border-emerald-900/50 dark:bg-emerald-900/20 dark:text-emerald-400"
        >
          <span class="font-sans">NF:</span>
          <span>{{ invoiceNumber }}</span>
        </button>
      }
    </div>
  }

  <div class="mt-2 flex flex-wrap items-center gap-2">
    <button
      type="button"
      (click)="copyBadge(orderType)"
      [title]="'Copiar tipo: ' + orderType"
      class="inline-flex cursor-pointer items-center gap-1 rounded-full border border-neutral-200 bg-neutral-100 px-2 py-0.5 text-xs font-semibold text-neutral-900 focus-visible:outline-none dark:border-neutral-700 dark:bg-neutral-800 dark:text-neutral-100"
    >
      <span class="font-medium text-neutral-500 dark:text-neutral-400">tipo:</span>
      <span>{{ orderType }}</span>
    </button>
    @if (metadata.orderIntegrator) {
      <button
        type="button"
        (click)="copyBadge(metadata.orderIntegrator)"
        [title]="'Copiar integrador: ' + metadata.orderIntegrator"
        class="inline-flex cursor-pointer items-center gap-1 rounded-full border border-neutral-200 bg-neutral-100 px-2 py-0.5 text-xs font-semibold text-neutral-900 focus-visible:outline-none dark:border-neutral-700 dark:bg-neutral-800 dark:text-neutral-100"
      >
        <span class="font-medium text-neutral-500 dark:text-neutral-400">integrador:</span>
        <span>{{ metadata.orderIntegrator }}</span>
      </button>
    }
    <button
      type="button"
      (click)="copyBadge(createdAt)"
      [title]="'Copiar data de criação: ' + createdAt"
      class="inline-flex cursor-pointer items-center gap-1 rounded-full border border-neutral-200 bg-neutral-100 px-2 py-0.5 text-xs font-semibold text-neutral-900 focus-visible:outline-none dark:border-neutral-700 dark:bg-neutral-800 dark:text-neutral-100"
    >
      <span class="font-medium text-neutral-500 dark:text-neutral-400">data de criação:</span>
      <span>{{ createdAt }}</span>
    </button>
  </div>

  <div class="mt-2 flex flex-wrap items-center gap-2">
    <button
      type="button"
      (click)="copyBadge(metadata.origin)"
      [title]="'Copiar origem: ' + metadata.origin"
      class="inline-flex cursor-pointer items-center gap-1 rounded-full border border-neutral-200 bg-neutral-100 px-2 py-0.5 text-xs font-semibold text-neutral-900 focus-visible:outline-none dark:border-neutral-700 dark:bg-neutral-800 dark:text-neutral-100"
    >
      <span class="font-medium text-neutral-500 dark:text-neutral-400">origem:</span>
      <span>{{ metadata.origin }}</span>
    </button>
    <button
      type="button"
      (click)="copyBadge(metadata.commercialPolicy)"
      [title]="'Copiar política: ' + metadata.commercialPolicy"
      class="inline-flex cursor-pointer items-center gap-1 rounded-full border border-neutral-200 bg-neutral-100 px-2 py-0.5 text-xs font-semibold text-neutral-900 focus-visible:outline-none dark:border-neutral-700 dark:bg-neutral-800 dark:text-neutral-100"
    >
      <span class="font-medium text-neutral-500 dark:text-neutral-400">política:</span>
      <span>{{ metadata.commercialPolicy }}</span>
    </button>
    <button
      type="button"
      (click)="copyBadge(metadata.vtexAccountId)"
      [title]="'Copiar conta vtex: ' + metadata.vtexAccountId"
      class="inline-flex cursor-pointer items-center gap-1 rounded-full border border-neutral-200 bg-neutral-100 px-2 py-0.5 text-xs font-semibold text-neutral-900 focus-visible:outline-none dark:border-neutral-700 dark:bg-neutral-800 dark:text-neutral-100"
    >
      <span class="font-medium text-neutral-500 dark:text-neutral-400">conta vtex:</span>
      <span>{{ metadata.vtexAccountId }}</span>
    </button>
  </div>
</div>
